module.exports = __webpack_public_path__ + "menu4.jpg?3987c31b8a07685d1421ac8fbc7a36c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu4.jpg
// module id = 557
// module chunks = 0